import React from 'react';
const TESTIMONIALS = [{
  quote: 'Llegué a Pancita Feliz completamente perdida. Mi hijo tenía diagnóstico pero yo no entendía qué hacer ni por dónde empezar. Gracias a la orientación que recibí, aprendí a leer su biología, a ajustar su alimentación y a conectar con los especialistas correctos. Hoy lo veo diferente — más presente, más tranquilo. Eso no tiene precio.',
  attribution: '— M.R., madre de un niño de 7 años, Miami, FL'
}, {
  quote: 'Lo que más me frustraba era saber que mi hija necesitaba una evaluación especializada y no poder costearla. Sentía que el sistema no estaba hecho para familias como la nuestra. Pancita Feliz nos abrió una puerta que creíamos cerrada. Por primera vez sentí que alguien realmente entendía lo que estábamos viviendo.',
  attribution: '— C.V., madre de una niña de 5 años, Doral, FL'
}];
export function TestimonialsSection() {
  return <section style={{
    background: '#f9fdf5',
    padding: '80px 20px'
  }} data-id="element-309" data-mp="32frfj3ez0ub8">
      <p style={{
      color: '#7DC920',
      fontSize: '11px',
      letterSpacing: '3px',
      fontWeight: 700,
      textAlign: 'center',
      marginBottom: '8px'
    }} data-id="element-310" data-mp="2v09o0odx324n">
        FAMILIAS QUE CONFÍAN EN NOSOTROS
      </p>
      <h2 className="mp-testimonials-title" style={{
      fontSize: '36px',
      fontWeight: 800,
      color: '#1a1a1a',
      textAlign: 'center',
      marginBottom: '48px'
    }} data-id="element-311" data-mp="2zrrg0mxypsdh">
        Lo Que Dicen las Familias
      </h2>
      <div className="mp-testimonials-grid" style={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '28px',
      maxWidth: '860px',
      margin: '0 auto'
    }} data-id="element-312" data-mp="2m0wddse247ic">
        {TESTIMONIALS.map(({
        quote,
        attribution
      }) => <figure key={attribution} style={{
        background: 'white',
        borderRadius: '16px',
        padding: '36px 32px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.07)',
        position: 'relative'
      }} data-id="element-313" data-mp="3sgylk5vu3i88">
            <span aria-hidden="true" style={{
          fontSize: '80px',
          color: '#e8f5e0',
          position: 'absolute',
          top: '16px',
          left: '24px',
          fontFamily: 'Georgia, serif',
          lineHeight: 1
        }} data-id="element-314" data-mp="dcyjwbb5fzq5">
              &ldquo;
            </span>
            <div aria-label="5 de 5 estrellas" style={{
          position: 'relative',
          color: '#f59e0b',
          fontSize: '16px',
          marginBottom: '16px'
        }} data-id="element-315" data-mp="3lqf8pl9x7mgy">
              ★★★★★
            </div>
            <blockquote style={{
          position: 'relative',
          fontSize: '16px',
          color: '#444',
          lineHeight: 1.7,
          fontStyle: 'italic',
          marginBottom: '24px'
        }} data-id="element-316" data-mp="2y12z4kaolce4">
              {quote}
            </blockquote>
            <figcaption style={{
          fontSize: '13px',
          fontWeight: 700,
          color: '#2d5a1b'
        }} data-id="element-317" data-mp="1b5y4ja8gzbha">
              {attribution}
            </figcaption>
          </figure>)}
      </div>
    </section>;
}